import React from "react";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import "./css/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faBookOpen,
  faGlobe,
  faCertificate,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faLightbulb,
  faChalkboardUser,
  faLaptopCode
} from "@fortawesome/free-solid-svg-icons";

function About() {
  return (
    <div>
      <Navbar page={"about"} />

      {/* Page Header Banner */}
      <div className="page-banner">
        <h1>About Consortium eLearning</h1>
        <p>Unlocking human potential and transforming the power of education globally.</p>
      </div>

      {/* Main About Section */}
      <section className="about-section">
        {/* Core Vision & Mission Grid */}
        <div className="about-grid">
          <div className="about-text">
            <h2>Empowering Skills & Maximizing Potential</h2>
            <p>
              Consortium eLearning platform is designed to help students, professionals, scholars,
              and skilled workers to leverage their skills and expertise. Consortium eLearning is
              here to offer new technologies and the latest instructional techniques to enhance their
              engagement, maximize the potential to learn remotely, and become more productive.
            </p>
            <p>
              This will potentially help learners to develop, learn and improve the skills and
              knowledge currently required to cope with challenging global situations.
            </p>
          </div>

          <div className="about-stats">
            <div className="stat-card">
              <FontAwesomeIcon icon={faUsers} style={{ fontSize: "1.8rem", color: "#2563eb", marginBottom: "8px" }} />
              <h3>1.2B+</h3>
              <p>Impacted Learners Worldwide</p>
            </div>
            <div className="stat-card">
              <FontAwesomeIcon icon={faBookOpen} style={{ fontSize: "1.8rem", color: "#0284c7", marginBottom: "8px" }} />
              <h3>180+</h3>
              <p>Countries Reached</p>
            </div>
            <div className="stat-card">
              <FontAwesomeIcon icon={faGlobe} style={{ fontSize: "1.8rem", color: "#10b981", marginBottom: "8px" }} />
              <h3>24/7</h3>
              <p>Remote Virtual Access</p>
            </div>
            <div className="stat-card">
              <FontAwesomeIcon icon={faCertificate} style={{ fontSize: "1.8rem", color: "#f59e0b", marginBottom: "8px" }} />
              <h3>100%</h3>
              <p>Accredited Digital Learning</p>
            </div>
          </div>
        </div>

        {/* Highlight Feature Box: Inclusive Classrooms */}
        <div style={{
          marginTop: "50px",
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          border: "1px solid #bae6fd",
          borderRadius: "16px",
          padding: "36px 32px",
          boxShadow: "0 8px 24px -4px rgba(2,132,199,0.08)"
        }}>
          <div style={{ display: "flex", gap: "20px", alignItems: "flex-start", flexWrap: "wrap" }}>
            <div style={{
              width: "52px",
              height: "52px",
              background: "linear-gradient(135deg, #2563eb, #0284c7)",
              color: "#fff",
              borderRadius: "14px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1.5rem",
              flexShrink: 0
            }}>
              <FontAwesomeIcon icon={faChalkboardUser} />
            </div>
            <div style={{ flex: 1, minWidth: "280px" }}>
              <h3 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "1.45rem", fontWeight: 800, color: "#0f172a", marginBottom: "10px" }}>
                Inclusive & Engaging Digital Classrooms
              </h3>
              <p style={{ color: "#334155", fontSize: "1rem", lineHeight: "1.7" }}>
                Consortium eLearning understands that learners thrive in digital classrooms that are engaging,
                learning-focused, and inclusive. We have developed an innovative digital
                learning platform to offer a wide variety of online learning opportunities to participate
                in continuous collaborative learning.
              </p>
            </div>
          </div>
        </div>

        {/* Feature Cards Grid */}
        <div style={{ marginTop: "50px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))", gap: "24px" }}>
          <div className="fea-box">
            <div className="fea-icon">
              <FontAwesomeIcon icon={faLightbulb} />
            </div>
            <h3 style={{ fontSize: "1.2rem" }}>Transformation Through Online Education</h3>
            <p style={{ lineHeight: 1.75 }}>
              Consortium eLearning offers opportunities for everyone to create change in their life,
              community, and eventually in the whole world. Working to unlock potential and transform the
              power of education, signing up empowers learners to step into virtual classrooms and become true change-makers.
            </p>
          </div>

          <div className="fea-box">
            <div className="fea-icon" style={{ background: "#e0f2fe", color: "#0284c7" }}>
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <h3 style={{ fontSize: "1.2rem" }}>Navigating the Global eLearning Shift</h3>
            <p style={{ lineHeight: 1.75 }}>
              Globally, over 1.2 billion children across 186 countries were affected by educational disruptions. This
              accelerated the rise of remote digital learning. Consortium eLearning bridges this gap, bringing people
              together to drive positive global change.
            </p>
          </div>
        </div>

        {/* Head Office Location Banner */}
        <div style={{
          marginTop: "56px",
          background: "linear-gradient(135deg, #060b17 0%, #0b152d 100%)",
          color: "#fff",
          borderRadius: "18px",
          padding: "44px 32px",
          textAlign: "center"
        }}>
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 800, fontSize: "1.9rem", marginBottom: "12px", color: "#fff" }}>
            Global Head Office
          </h2>
          <p style={{ color: "#94a3b8", fontSize: "1.05rem", marginBottom: "24px" }}>
            Connecting learners and academic professionals across continents
          </p>
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            background: "rgba(255,255,255,0.07)",
            padding: "14px 26px",
            borderRadius: "12px",
            border: "1px solid rgba(255,255,255,0.12)"
          }}>
            <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#38bdf8", fontSize: "1.3rem" }} />
            <span style={{ color: "#f8fafc", fontSize: "1rem", fontWeight: 600, textAlign: "left" }}>
              6660 Kennedy Road, Suites 201 & 205, Mississauga, Ontario L5T 2M9 Canada
            </span>
          </div>
        </div>

        {/* Contact Links */}
        <div style={{ marginTop: "44px", textAlign: "center" }}>
          <h3 style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 700, marginBottom: "18px", color: "#0f172a" }}>
            Get In Touch With Our Team
          </h3>
          <div style={{ display: "flex", justifyContent: "center", gap: "36px", flexWrap: "wrap" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#64748b" }}>
              <FontAwesomeIcon icon={faEnvelope} style={{ color: "#2563eb", fontSize: "1.1rem" }} />
              <a href="mailto:info@consortiumelearning.com" style={{ color: "#2563eb", textDecoration: "none", fontWeight: 600 }}>
                info@consortiumelearning.com
              </a>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", color: "#64748b" }}>
              <FontAwesomeIcon icon={faPhone} style={{ color: "#2563eb", fontSize: "1.1rem" }} />
              <a href="tel:+442079460912" style={{ color: "#2563eb", textDecoration: "none", fontWeight: 600 }}>
                +44 (0) 20 7946 0912
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default About;
